import { ANY_ROOM_TYPE } from 'pages/common/const';
import { Inputs } from '../types';

export const getProjectUpdatedCustomEventPayload = (inputsData: Inputs & { roomType?: string }) => {
  let projectConfigurationParameters = [];

  if (Boolean(inputsData.roomType) && inputsData.roomType !== ANY_ROOM_TYPE) {
    projectConfigurationParameters.push({
      key: 'roomType',
      value: inputsData.roomType!,
    });
  }

  if (Boolean(inputsData.width) && Boolean(inputsData.length)) {
    projectConfigurationParameters.push({
      key: 'width',
      value: inputsData.width!,
    });
    projectConfigurationParameters.push({
      key: 'length',
      value: inputsData.length!,
    });
  }

  if (Boolean(inputsData.area)) {
    projectConfigurationParameters.push({
      key: 'area',
      value: inputsData.area!,
    });
  }

  if (Boolean(inputsData.thickness)) {
    projectConfigurationParameters.push({
      key: 'layingType',
      value: inputsData.thickness!,
    });
  }

  return projectConfigurationParameters;
};
